"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'remote-user/';
exports.default = {
  HOOK_EXTRA_INFO_INIT: _DOMAIN + 'HOOK_EXTRA_INFO_INIT',
  HOOK_EXTRA_INFO_SUCCESS: _DOMAIN + 'HOOK_EXTRA_INFO_SUCCESS',
  HOOK_EXTRA_INFO_FAILURE: _DOMAIN + 'HOOK_EXTRA_INFO_FAILURE',
  UNHOOK_EXTRA_INFO_SUCCESS: _DOMAIN + 'UNHOOK_EXTRA_INFO_SUCCESS',
  ON_EXTRA_INFO_UPDATE: _DOMAIN + 'ON_EXTRA_INFO_UPDATE',
  RESET_NEW_REVIEWING_ITEMS_COUNTER_INIT: _DOMAIN + 'RESET_NEW_REVIEWING_ITEMS_COUNTER_INIT',
  RESET_NEW_REVIEWING_ITEMS_COUNTER_SUCCESS: _DOMAIN + 'RESET_NEW_REVIEWING_ITEMS_COUNTER_SUCCESS',
  RESET_NEW_REVIEWING_ITEMS_COUNTER_FAILURE: _DOMAIN + 'RESET_NEW_REVIEWING_ITEMS_COUNTER_FAILURE',
  RESET_NEW_IDLE_ITEMS_COUNTER_INIT: _DOMAIN + 'RESET_NEW_IDLE_ITEMS_COUNTER_INIT',
  RESET_NEW_IDLE_ITEMS_COUNTER_SUCCESS: _DOMAIN + 'RESET_NEW_IDLE_ITEMS_COUNTER_SUCCESS',
  RESET_NEW_IDLE_ITEMS_COUNTER_FAILURE: _DOMAIN + 'RESET_NEW_IDLE_ITEMS_COUNTER_FAILURE',
  CHANGE_NICKNAME_INIT: _DOMAIN + 'CHANGE_NICKNAME_INIT',
  CHANGE_NICKNAME_SUCCESS: _DOMAIN + 'CHANGE_NICKNAME_SUCCESS',
  CHANGE_NICKNAME_FAILURE: _DOMAIN + 'CHANGE_NICKNAME_FAILURE'
};